import { useState } from "react";
import { addUser } from "../api";

export default function AddUser({ onAdd }) {
  const [name, setName] = useState("");

  const handleAdd = async () => {
    if (!name.trim()) return;
    try {
      await addUser(name);
      setName("");
      onAdd();
    } catch (err) {
      console.error("Error adding user:", err);
      alert("Failed to add user. Please try again.");
    }
  };

  return (
    <div>
      <input
        value={name}
        placeholder="New user"
        onChange={e => setName(e.target.value)}
      />
      <button onClick={handleAdd}>Add</button>
    </div>
  );
}